export default __webpack_public_path__ + "static/media/aboutbg.16355562.jpeg";